const oid = require('./oid.js');
const rfc5280 = require('./rfc5280');
const SM2 = require('../sm2');
const utils = require('../utils');

/**
 * @param {
 *  countryName,
 *  province,
 *  localityName,
 *  organizationName,
 *  organizationUnitName,
 *  commonName,
 *  email,
 *  challengePassword
 *  publicKey
 *  privateKey
 * } param
 */
const genCsr = function ({
  countryName,
  province,
  localityName,
  organizationName,
  organizationUnitName,
  commonName,
  email,
  challengePassword,
  publicKey,
  privateKey,
}) {
  const certificationRequest = {
    certificationRequestInfo: {
      version: 0,
      subject: { type: 'rdnSequence', value: [] },
      subjectPKInfo: {
        algorithm: { algorithm: oid.ECCPubKey.split('.'), subAlgorithm: oid.SM2ECC.split('.') },
        subjectPublicKey: { data: Buffer.from(publicKey, 'hex') },
      },
      attributes: {
        type: oid.ChallengePassword.split('.'),
        values: [],
      },
    },
    signatureAlgorithm: { algorithm: oid.SM2SigningWithSM3.split('.') },
    signature: { data: '' },
  };
  if (countryName) {
    certificationRequest.certificationRequestInfo.subject.value = [
      [
        {
          type: oid.CountryName.split('.'),
          value: {
            type: 'printableString',
            value: countryName,
          },
        },
      ],
    ];
  }
  if (province) {
    certificationRequest.certificationRequestInfo.subject.value.push([
      {
        type: oid.StateOrProvinceName.split('.'),
        value: {
          type: 'utf8String',
          value: province,
        },
      },
    ]);
  }
  if (localityName) {
    certificationRequest.certificationRequestInfo.subject.value.push([
      {
        type: oid.LocalityName.split('.'),
        value: {
          type: 'utf8String',
          value: localityName,
        },
      },
    ]);
  }
  if (organizationName) {
    certificationRequest.certificationRequestInfo.subject.value.push([
      {
        type: oid.OrganizationName.split('.'),
        value: {
          type: 'utf8String',
          value: organizationName,
        },
      },
    ]);
  }
  if (organizationUnitName) {
    certificationRequest.certificationRequestInfo.subject.value.push([
      {
        type: oid.OrganizationalUnitName.split('.'),
        value: {
          type: 'utf8String',
          value: organizationUnitName,
        },
      },
    ]);
  }
  if (commonName) {
    certificationRequest.certificationRequestInfo.subject.value.push([
      {
        type: oid.CommonName.split('.'),
        value: {
          type: 'utf8String',
          value: commonName,
        },
      },
    ]);
  }
  if (email) {
    certificationRequest.certificationRequestInfo.subject.value.push([
      {
        type: oid.Email.split('.'),
        value: {
          type: 'ia5String',
          value: email,
        },
      },
    ]);
  }
  if (challengePassword) {
    certificationRequest.certificationRequestInfo.attributes.values = [
      {
        type: 'utf8String',
        value: challengePassword,
      },
    ];
  }
  const requestInfoDer = rfc5280.CertificationRequestInfo.encode(certificationRequest.certificationRequestInfo, 'der');
  const signMsg = SM2Sign(publicKey, privateKey, requestInfoDer);
  certificationRequest.signature = { data: Buffer.from(signMsg, 'hex') };
  // console.log(signMsg, SM2Verify(publicKey, requestInfoDer, signMsg));
  const csr = rfc5280.CertificationRequest.encode(certificationRequest, 'der');
  const result = `-----BEGIN CERTIFICATE REQUEST-----
${utils.byteArrayToBase64(csr)}
-----END CERTIFICATE REQUEST-----`;
  return result;
};
const SM2Sign = function (publickey, privateKey, msg) {
  const sm2 = new SM2();
  const idByteArray = utils.stringToByteArrayInUtf8('1234567812345678');
  return sm2.sign(publickey, privateKey, msg, idByteArray);
};

// const SM2Verify = function (publicKey, msg, sig) {
//   const sm2 = new SM2();
//   const idByteArray = utils.stringToByteArrayInUtf8('1234567812345678');
//   return sm2.verify(publicKey, msg, idByteArray, sig);
// };

module.exports = { genCsr };
